module.exports = __webpack_public_path__ + "img/template-option-icon.11a2fa8b.svg";